import { render, staticRenderFns } from "./Rectangle.vue?vue&type=template&id=24ec6bd8&lang=pug&"
import script from "./Rectangle.vue?vue&type=script&lang=js&"
export * from "./Rectangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports